module.exports = __webpack_public_path__ + "img/DMS.0863b036.png";